export default {
    "general": {
        "Save"                        : "Salvar",
        "Send"                        : "Enviar",
        "Cancel"                      : "Cancelar",
        "istobal-logo"                : "ISTOBAL - Vehicle Wash & Care",
        "logo_istobal"                : "ISTOBAL - Vehicle Wash & Care",
        "Models"                      : "Modelos",
        "Plain"                       : "Simple",
        "Rocket"                      : "Rocket",
        "Zenit"                       : "Zenit",
        "Cubik"                       : "Cubik",
        "PremiumLed"                  : "Premium com Led",
        "PremiumMethacrylate"         : "Premium Metacrilato",
        "Premium"                     : "Premium",
        "Structure"                   : "Estrutura",
        "estructura"                  : "Estrutura",
        "Fairing"                     : "Carenagem",
        "carenado"                    : "Carenagem",
        "Front/rearFairing"           : "Cabeçalho superior",
        "cabut"                       : "Cabeçalhos superiores",
        "Front/rearFairings"          : "Cabeçalhos superiores",
        "cabuts"                      : "Cabeçalhos superiores",
        "Door"                        : "Porta",
        "puerta"                      : "Porta",
        "Doors"                       : "Portas",
        "PlainDoor"                   : "Plano",
        "Led"                         : "Led",
        "WheelWash"                   : "Lavagem de rodas",
        "lavarruedas"                 : "Lavagem de rodas",
        "Light"                       : "Luz",
        "luminoso"                    : "Luz",
        "luminososuperior"            : "Luz superior",
        "Lights"                      : "Luzes",
        "TrafficLight"                : "Semáforo",
        "TrafficLightPositioning"     : "Semáforo do posicionamento",
        "Sferic"                      : "Sferic",
        "Boomerang"                   : "Boomerang",
        "Linear"                      : "Linear",
        "Pictogram"                   : "Pictograma",
        "pictograma"                  : "Pictograma",
        "pictogramasuperior"          : "Pictograma superior",
        "Pictograms"                  : "Pictogramas",
        "PitLane"                     : "Pit Lane",
        "Pictogram2020"               : "Pictograma 2020",
        "Volaverunt"                  : "Volaverunt",
        "VolaveruntBlanco"            : "Volaverunt branco",
        "VolaveruntNegro"             : "Volaverunt preto",
        "Color"                       : "Cor",
        "Silver"                      : "Silver",
        "Hexa"                        : "Hexa",
        "Brushes"                     : "Escovas",
        "basicSelector"               : "Básico",
        "basicSelectorInvert"         : "Avançado",
        "advancedSelector"            : "Avançado",
        "Flat"                        : "Plana",
        "Liso"                        : "Plana",
        "3stripes"                    : "Listras",
        "Bandas"                      : "Listras",
        "Streaked"                    : "Personalizada",
        "Rayado"                      : "Personalizada",
        "CONFIGURATOR"                : "CONFIGURADOR",
        "SelectAnOption"              : "Selecione um rollover para iniciar a configuração",
        "select"                      : "selecionar",
        "ClickSelectColor"            : "Clique para selecionar a cor",
        "ClickSelectColorPatron"      : "Clique para colocar as cores",
        "ColorSelector"               : "Seletor de cores",
        "SelectColor"                 : "Selecione a cor",
        "Yes"                         : "Sim",
        "No"                          : "Não",
        "SaveConfig"                  : "Salvar",
        "Share"                       : "Compartilhar",
        "ContactUs"                   : "Contate-nos",
        "ShareContact"                : "Compartilhe ou salve",
        "FrontImage"                  : "Imagem frontal",
        "BackImage"                   : "Imagem traseira",
        "FrontRender"                 : "Renderização frontal",
        "BackRender"                  : "Renderização traseira",
        "PrivacyText"                 : "As imagens, vídeos e informações que constam neste espaço são meramente ilustrativas e não constituem uma oferta comercial. Pode contactar o departamento comercial da ISTOBAL para qualquer informação adicional ou pedido relacionado com os nossos produtos. A informação contida neste configurador não pode ser considerada uma oferta de venda ou outro tipo de contrato ou acordo com a ISTOBAL, SA ou com entidades pertencentes ao seu grupo. Caso o utilizador pretenda adquirir um produto ISTOBAL com as características e equipamentos indicados na configuração, poderá contactar a Rede Comercial ISTOBAL S.A. que os informará sobre os detalhes finais do produto. ISTOBAL SA . não garante que a configuração específica escolhida pelo Usuário esteja total ou parcialmente disponível.",
        "RightsReserved"              : "Todos os direitos reservados",
        "E-mail"                      : "E-mail",
        "E-mailPlaceholder"           : "Seu E-mail",
        "DownloadPDF"                 : "Baixar PDF",
        "CopyLink"                    : "Cópia link",
        "Help"                        : "Ajuda",
        "NeedHelp"                    : "Preciso de ajuda?",
        "CallTo"                      : "Ligue para +34 96 111 10 20",
        "CallToPhone"                 : "+34961111020",
        "ContactUsTitle"              : "Entre em contato conosco, um de nossos especialistas entrará em contato com você em breve",
        "ContactUsIframeURL_es_en"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhl",
        "ContactUsIframeURL_es_es"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhp",
        "ContactUsIframeURL_int_en"   : "https://go.istobal.com/l/954553/2022-05-31/4nfhl",
        "ContactUsIframeURL_int_es"   : "https://go.istobal.com/l/954553/2022-05-31/4nfhp",
        "ContactUsIframeURL_us_es"    : "https://go.istobal.com/l/954553/2022-05-10/411s2",
        "ContactUsIframeURL_us_en_us" : "https://go.istobal.com/l/954553/2022-05-10/411s2",
        "ContactUsIframeURL_br_en"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhl",
        "ContactUsIframeURL_br_pt"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhp",
        "AskInformation"              : "Peça mais informações",
        "Exit"                        : "Saída",
        "Close"                       : "Fechar",
        "ChooseAnOptionCustomRollover": "Selecione o que você prefere fazer com a ponte de lavagem que você configurou",
        "clipboardLink"               : "Link copiado para a área de transferência!",
        "emailSending"                : "Enviando a ... ",
        "emailSent"                   : "Enviado!",
        "emailError"                  : "Erro! Tente novamente em alguns minutos ou baixe o PDF",
        "emailFormat"                 : "Entre com um email válido",
        "ConfiguracionesiQuote"       : "Configurações padrão:",
        "Aceptar"                     : "Concordar",
        "Notice"                      : "Perceber",
        "NoticeText"                  : 'Lembre-se que o iQuote permite configurar os Rollovers com uma cor duas cores (com quatro tipos de combinações). O resto das configurações não estão incluídas no iQuote e não podem ser produzidas.<br /><br />Pressione o ícone de informação <span data-v-16b6fa28="" class="icon is-small"><svg class="svg-inline--fa fa-info-circle fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg><!-- <i class="fas fa-info-circle"></i> --></span> para mais informações sobre as opções disponíveis em cada máquina.',
        "ConfStandardIQuote"          : 'Configurações padrão',
        "UnColor"                     : '1A',
        "Central"                     : 'Frente',
        "Posterior"                   : 'Traseiro'

    }

}
